export default "__VITE_ASSET__39114491__"